export const shiftColors = {
    blue: { dark: "#64b5f6", light: "#BBDEFB" },
    red: { dark: "#ef7776", light: "#FFCFD4" },
    yellow: { dark: "#FCEB55", light: "#FFF9C4" },
    orange: { dark: "#FFA726", light: "#FFE0B2" },
    green: { dark: "#72BB66", light: "#CCE6C8" },
    purple: { dark: "#e094f9", light: "#ecc0fb" },
    sand: { dark: "#edc9a3", light: "#f8eada" },
    turquoise: { dark: "#7ae3c2", light: "#b3eeda" },
    pink: { dark: "#fa85dc", light: "#fcb8ea" },
    olive: { dark: "#d8f86a", light: "#effcc1" },
    teal: { dark: "#44d2df", light: "#b1ecf0" },
    indigo: { dark: "#a5a9fb", light: "#cacbfc" },
};

export type ColorKey = keyof typeof shiftColors;

export enum ColorCriterion {
  Employee = 0,
  Route = 1,
  Vehicle = 2,
}

export interface ColorSchemeDto {
  id: string | null;
  rowId: string | null;
  scope: string;
  enabled: boolean;
  criterion: ColorCriterion;
  defaultColorKey: ColorKey;
  mappings: Record<string, ColorKey>;
}
